import { Grid } from "@mui/material";
import { countryNameHelper, getAssets } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { weatherAtom } from "@_recoil/_state";
import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { useRecoilValue, useSetRecoilState } from "recoil";
import styles from "./study_post_admission.module.scss";

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronRight
      className={`${className} InstructionGallerySliderNext`}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronLeft
      className={`${className} InstructionGallerySliderPrev`}
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 4000,
  infinite: true,
  speed: 700,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerPadding: "60px",
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        arrows: true,
        dots: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const StudyPostAdmission = ({ countryInfo }) => {
  const router = useRouter();
  const { query } = router;
  const weatherAtomState = useRecoilValue(weatherAtom);
  const setWeather = useSetRecoilState(weatherAtom);

  const [visaData, setVisaData] = useState([]);
  const [costData, setCostData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // fetch visa data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(
          `/public/country/visa-options/${countryInfo?.countryId}`
        );
        setLoading(false);
        setVisaData(res.data);
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, [countryInfo?.countryId]);

  // fetch living cost data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(
          `/public/country/living-cost/${countryInfo?.countryId}`
        );
        setLoading(false);
        setCostData(res.data);
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, [countryInfo?.countryId]);

  const handleChange = (e) => {
    setWeather((curVal) => ({ ...curVal, currentMonth: e.target.value }));
  };
  const fetchWeatherData = async () => {
    await API.get(
      `/public/weather?country=${weatherAtomState.countryName}&month=${weatherAtomState.currentMonth}`
    )
      .then((resp) => {
        if (!resp.error) {
          setWeather((curVal) => ({
            ...curVal,
            weatherData: resp.data,
          }));
        }
      })
      .catch((e) => {});
  };

  useEffect(() => {
    setWeather((curVal) => ({ ...curVal, countryName: query.country_name }));
  }, [query.country_name]);

  useEffect(() => {
    if (weatherAtomState.countryName && weatherAtomState.countryName != "") {
      fetchWeatherData();
    }
  }, [weatherAtomState.countryName, weatherAtomState.currentMonth]);

  return (
    <section className={styles.section_post_admission}>
      <div className="container">
        <h2 className={styles.heading}>
          Living in{" "}
          {countryInfo?.name ? <>{countryNameHelper(countryInfo)}</> : ""}
        </h2>
        <div className={styles.post_admission_wrapper}>
          <Grid container spacing={{ xs: 0, sm: 0, md: 5 }}>
            <Grid item md={6} sm={12} xs={12}>
              {/* card start*/}
              {visaData?.length > 0 && (
                <div className={`visa-option-slider`}>
                  <div className={`${styles.sub_title} ${styles.visa_option}`}>
                    Visa Options{" "}
                    {countryInfo?.name ? (
                      <>({countryNameHelper(countryInfo)})</>
                    ) : (
                      ""
                    )}
                  </div>
                  <Slider {...settings}>
                    {visaData.map((visa, i) => (
                      <div className={styles.card_wrapper}>
                        <div className={styles.card_title}>
                          {visa?.visaTitle}
                        </div>
                        <div className={styles.quick_info_wrapper}>
                          <span>
                            Cost - {countryInfo?.currencySymbol}
                            {visa?.visaFee}
                          </span>
                          <span>Type - {visa?.visaType}</span>
                        </div>
                        <p className={styles.card_description}>
                          {visa?.description}
                        </p>
                      </div>
                    ))}
                  </Slider>
                </div>
              )}
              {/* card end*/}

              <div className={styles.costof_living_wrapper}>
                <div className={styles.sub_title}>
                  Cost of Living{" "}
                  {countryInfo?.name ? (
                    <>({countryNameHelper(countryInfo)})</>
                  ) : (
                    ""
                  )}
                </div>
                <div className={styles.low_high_indicator_wrapper}>
                  <div className={styles.low_high_image_wrapper}>
                    <img
                      src={getAssets(
                        "assets/images/study/low_high_indicator_wheel.png"
                      )}
                      alt="Low High Indicator Wheel"
                    />
                    <img
                      className={styles.low_high_indicator}
                      src={getAssets(
                        "assets/images/study/low_high_indicator.png"
                      )}
                      alt="Low High Indicator"
                    />
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item md={6} sm={12} xs={12}>
              {/* Weather box start */}
              {weatherAtomState.weatherData.length > 0 && (
                <div className={styles.weather_box_wrapper}>
                  <div className={styles.weather_heading}>
                    <div className={styles.sub_title}>
                      Weather{" "}
                      {countryInfo?.name ? (
                        <>({countryNameHelper(countryInfo)})</>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className={styles.select_dropdown_wrapper}>
                      <select
                        value={weatherAtomState.currentMonth}
                        onChange={handleChange}
                      >
                        <option value="January">January</option>
                        <option value="February">February</option>
                        <option value="March">March</option>
                        <option value="April">April</option>
                        <option value="May">May</option>
                        <option value="June">June</option>
                        <option value="July">July</option>
                        <option value="August">August</option>
                        <option value="September">September</option>
                        <option value="October">October</option>
                        <option value="November">November</option>
                        <option value="December">December</option>
                      </select>
                      <p>C°</p>
                    </div>
                  </div>

                  <ul className={styles.weather_list}>
                    {weatherAtomState.weatherData.map((weather, i) => (
                      <li key={i}>
                        <span className={styles.city}>{weather.name}</span>
                        <span className={styles.temperature}>
                          {weather.minTemp}° ~ {weather.maxTemp}°
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {/* Weather box end */}

              {/* Living cost start */}
              {costData?.length > 0 && (
                <div className={styles.living_cost_wrapper}>
                  <div className={styles.sub_title}>
                    Monthly Living Expenses{" "}
                    {countryInfo?.name ? (
                      <>({countryNameHelper(countryInfo)})</>
                    ) : (
                      ""
                    )}
                  </div>
                  <ul className={styles.living_cost_list}>
                    {costData?.map((cost, i) => {
                      return (
                        <Fragment key={i}>
                          {cost?.icon !== null && (
                            <li>
                              <div className={styles.cost_image}>
                                <img
                                  src={cost?.icon?.src}
                                  alt={cost?.icon?.alt || "Alt text"}
                                />
                              </div>
                              <div className={styles.cost_title}>
                                {cost?.livingCostName}
                              </div>
                              <div className={styles.cost_range}>
                                {countryInfo?.currencySymbol}
                                {cost?.amountFrom}-{countryInfo?.currencySymbol}
                                {cost?.amountTo}
                              </div>
                            </li>
                          )}
                        </Fragment>
                      );
                    })}
                  </ul>
                </div>
              )}
              {/* Living cost end */}
            </Grid>
          </Grid>
        </div>
      </div>
    </section>
  );
};

export default StudyPostAdmission;
